import { Alert, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ApiService from '../../../service/ApiService';

/**
 * Giriş yapmış kullanıcının kendi parolasını değiştirmesi (header → profil menüsü).
 *
 * Mevcut parola, oturum zaten açık olsa bile SORULUR: açık kalmış bir ekranın başına geçen birinin
 * parolayı değiştirip hesabı ele geçirmesini engeller.
 *
 * Parola değişince sunucudaki damga da değişir ve kullanıcının TÜM token'ları — bu oturum dahil —
 * geçersiz olur. Bu yüzden başarıdan sonra oturumu kapatıp giriş ekranına dönüyoruz; aksi halde
 * kullanıcı, bir sonraki isteğinde sebepsiz görünen bir 401 ile karşılaşırdı.
 */
export default function ChangePasswordModal({ open, onClose, onChanged }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        const values = await form.validateFields();

        setLoading(true);
        const res = await ApiService.User.ChangeOwnPassword(values.currentPassword, values.newPassword);
        setLoading(false);

        if (res.success) {
            form.resetFields();
            onClose();
            onChanged();
        }
    };

    const close = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title={t('Change Password')}
            open={open}
            onOk={submit}
            onCancel={close}
            confirmLoading={loading}
            okText={t('Save')}
            cancelText={t('Cancel')}
            destroyOnClose
        >
            <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
                message={t('After changing your password you will be signed out and must log in again.')}
            />

            <Form form={form} layout="vertical" onFinish={submit}>
                <Form.Item
                    label={t('Current Password')}
                    name="currentPassword"
                    rules={[{ required: true, message: t('Please input your current password!') }]}
                >
                    <Input.Password autoComplete="current-password" />
                </Form.Item>

                <Form.Item
                    label={t('New Password')}
                    name="newPassword"
                    rules={[
                        { required: true, message: t('Please input your new password!') },
                        { min: 8, message: t('Password must be at least 8 characters.') },
                    ]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>

                <Form.Item
                    label={t('New Password (again)')}
                    name="newPasswordRepeat"
                    dependencies={['newPassword']}
                    rules={[
                        { required: true, message: t('Please repeat your new password!') },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error(t('Passwords do not match.')));
                            },
                        }),
                    ]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
            </Form>
        </Modal>
    );
}
